<script setup lang="ts">
interface Props {
  descriptions: string[]
}

defineProps<Props>()
</script>

<template>
  <ul>
    <li
      v-for="description in descriptions"
      :key="description"
      class="font-light"
    >
      • {{ description }}
    </li>
  </ul>
</template>
